const CANCEL_REASONS = [
  'no_longer_needed',
  'not_utilizing_hours',
  'personal_circumstances',
  'dissatisfied_with_tutor',
  'found_another_option',
  'technology_platform',
  'membership_renewal',
  'other',
] as const;

export default CANCEL_REASONS;
